module.exports = __webpack_public_path__ + "img/sample_ic_front.439e2e6d.webp";